import * as React from 'react';

import { Facebook } from './Facebook';
import { Instagram } from './Instagram';
import { LinkedIn } from './LinkedIn';
import { X } from './X';
import { YouTube } from './YouTube';

export type SocialPlatform = 'facebook' | 'x' | 'instagram' | 'linkedin' | 'youtube';

export interface SocialIconProps {
  platform: SocialPlatform | string;
  className?: string;
}

const ICONS: Record<SocialPlatform, React.FC<{ className?: string }>> = {
  facebook: Facebook,
  x: X,
  instagram: Instagram,
  linkedin: LinkedIn,
  youtube: YouTube,
};

export const isSupportedPlatform = (platform: string): platform is SocialPlatform =>
  platform in ICONS;

export const SocialIcon: React.FC<SocialIconProps> = ({ platform, className }) => {
  const Icon = ICONS[platform as SocialPlatform];
  if (!Icon) return null;
  return <Icon className={className} />;
};
